/**
 * From GraphQL Specification Schema:
 * The Int scalar type represents non-fractional signed whole numeric values. Int can represent values between -(2^31) and 2^31 - 1.
 */
export const isSafeInt = (value) =>
  Number.isInteger(value) && Math.abs(value) <= Math.pow(2, 31) - 1;
